import { render, staticRenderFns } from "./carDispatchForm.vue?vue&type=template&id=74a5a05e&scoped=true"
import script from "./carDispatchForm.vue?vue&type=script&setup=true&lang=js"
export * from "./carDispatchForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./carDispatchForm.vue?vue&type=style&index=0&id=74a5a05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5a05e",
  null
  
)

export default component.exports